import { connect } from "react-redux";
import * as actions from "MODULES/SalesOrders/actions";

export default function withSalesOrder(Component) {
  return connect(
    state => ({
      salesOrder: state.salesOrderDetail.get("salesOrder")
    }),
    {
      updateSalesOrder: actions.update,
      refresh: actions.fetch,
      expireLineItems: actions.expireLineItems,
      cancel: actions.cancel,
      reverseCancellation: actions.soCancellationReversal
    }
  )(Component);
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/decorators/withSalesOrder.jsx